import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-helpdesk-rvc',
  templateUrl: './helpdesk-rvc.component.html',
  styleUrls: ['./helpdesk-rvc.component.scss']
})
export class HelpdeskRvcComponent implements OnInit, AfterViewInit {

  @ViewChild('historyForm') historyForm: NgForm;

  formData = {
    vin: '',
    dealercode: ''
  };

  userType: string = '';
  rvcData: any[] = [];
  public tokenDetails: any;
  showloading: boolean = false;
  receivedresult: boolean = false;

  private previousVin: string = '';
  private previousDealercode: string = '';

  constructor(
    private service: ApifirstService
  ) { }

  ngOnInit(): void {
    this.service.tokenObj.subscribe((data) => {
      this.tokenDetails = data;
      this.userType = this.tokenDetails.userType;

      if (this.userType === 'PTS_DEALER') {
        this.formData.dealercode = this.tokenDetails.dealerCode;
      }
      this.previousVin = this.formData.vin;
      this.previousDealercode = this.formData.dealercode;
    });
  }

  ngAfterViewInit(): void {
    if (this.userType === 'PTS_DEALER' || this.userType === 'FORD_INTERNAL') {
      setTimeout(() => {
        this.filter();
      });
    }
  }

  handleInput(field: 'vin' | 'dealercode', event: Event): void {
    const input = event.target as HTMLInputElement;
    const valueWithSpecialChars = input.value;

    const cleanValue = valueWithSpecialChars.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    const vinWasPopulatedBeforeThisEvent = this.previousVin.length > 0;
    const dealercodeWasPopulatedBeforeThisEvent = this.previousDealercode.length > 0;

    if (input.value !== cleanValue) {
      input.value = cleanValue;
    }
    this.formData[field] = cleanValue;

    if (field === 'vin' && vinWasPopulatedBeforeThisEvent && this.formData.vin.length === 0) {
      this.filter();
    } else if (field === 'dealercode' && dealercodeWasPopulatedBeforeThisEvent && this.formData.dealercode.length === 0) {
      this.filter();
    }

    if (field === 'vin') {
      this.previousVin = this.formData.vin;
    } else if (field === 'dealercode') {
      this.previousDealercode = this.formData.dealercode;
    }
  }

  filter(): void {
    this.rvcData = [];
    this.showloading = true;
    this.receivedresult = false;

    let payload = { ...this.formData };

    this.service.getRvcsByFilter(payload).subscribe({
      next: (data) => {
        this.rvcData = data;
        this.receivedresult = true;
        this.showloading = false;
      },
      error: (err) => {
        console.error('Error fetching RVC data:', err);
        this.rvcData = [];
        this.receivedresult = true;
        this.showloading = false;
      }
    });
  }

  get isFilterButtonDisabled(): boolean {
    if (!this.historyForm) {
      return true;
    }

    const vinLength = this.formData.vin?.length;

    if (this.userType === 'PTS_DEALER') {
      return vinLength !== 17;
    } else {
      const hasNoInput = !this.formData.vin && !this.formData.dealercode;
      const vinIsPartial = vinLength > 0 && vinLength !== 17;
      return hasNoInput || vinIsPartial;
    }
  }
}